import { IndexPageVariant, OS } from '../models/indexPageVariant';

export const androidVariant: IndexPageVariant = {
  id: OS.ANDROID,
  name: 'Android',
  installationSteps: [],
  downloadLink: 'verify-playstore.lnk'
};
